module.exports = __webpack_public_path__ + "static/media/btech.f4b821a4.png";